import DryBeansProduct from 'models/DryBeansProduct'

export const packagingInitialState = {
  category: DryBeansProduct.category,
  subCategory: DryBeansProduct.subCategory,
  BeanPeaLentilType: {
    value: '',
    label: 'Type',
  },
  BeanPeaLentilSize: '',
}

export const beanTypeOptions = [
  {
    value: '',
    label: 'Type',
    isDisabled: true,
  },
  {
    value: 'Beans',
    label: 'Beans',
  },
  {
    value: 'Peas',
    label: 'Peas',
  },
  {
    value: 'Lentils',
    label: 'Lentils',
  },
]
